import { AthosFetcher } from '../classes/athos-fetcher'
import { normaliseFacets, normaliseResults } from '../helpers/normalisers'
import { generateAthosProvider } from './provider'
import { isAthosInstockOnly } from '../athos-utils'

export class AthosCollection extends AthosFetcher {
  generateURL() {
    return super.generateURL('/category')
  }

  updateParams(options = {}) {
    const { handle, originalQuery, sort, filters, page, resultsPerPage } = options

    this.params.setDomainParam()
    this.params.set('resultsFormat', 'native')
    this.params.set('redirectResponse', 'full')
    this.params.set('bgfilter.collection_handle', handle)
    if (isAthosInstockOnly()) this.params.set('bgfilter.ss_available', 1)

    if (originalQuery) this.params.set('oq', originalQuery)
    if (page) this.params.set('page', page)
    if (resultsPerPage) this.params.set('resultsPerPage', resultsPerPage)

    if (sort) this.params.setSort(sort)
    else this.params.clearSort()
    this.params.setFilters(filters instanceof Set ? filters : new Set())

    super.updateParams()
  }
}

export const AthosCollectionProvider = generateAthosProvider(AthosCollection, (results) => {
  return {
    ...results,
    facets: normaliseFacets(results?.facets || []),
    results: normaliseResults(results?.results)
  }
})
